import React, { memo } from 'react';
import styled, { css } from 'styled-components';
import { green, red } from '@avangard/ui/colors';

type TableCellResultProps = {
    children: React.ReactNode;
    isSuccess: boolean;
    onClick?: (event: React.MouseEvent) => void;
};

const Root = styled.div<{ isSuccess: boolean; onClick?: (event: React.MouseEvent) => void }>`
    display: inline-flex;
    color: ${p => (p.isSuccess ? green[100] : red[100])};

    ${({ isSuccess, onClick }) =>
        onClick &&
        css`
            cursor: pointer;
            border-bottom: 1px dashed ${p => (isSuccess ? green[100] : red[100])};
            transition: opacity 0.2s;

            &:hover {
                opacity: 0.5;
            }
        `}
`;

const TableCellResult = memo((props: TableCellResultProps): React.ReactElement => {
    const { children, isSuccess, onClick } = props;

    return (
        <Root isSuccess={isSuccess} onClick={onClick}>
            {children}
        </Root>
    );
});

export { TableCellResult };
